module.exports = __webpack_public_path__ + "media/src/images/icon__happy--2-9ce49d54329ae0e227f9c23534bafe63.png";